<template>
  <div class="wrapper">
    <div class="inp">
      <span class="label">扫码登录...</span>
      <!-- <input type="text" ref="input" />
      <el-button type="primary" @click="handleNext">下一步</el-button> -->
    </div>
  </div>
</template>

<script>
import { getUrl } from "@/api/login";
export default {
  data() {
    return {
      appId: "",
      redirectUri: "",
    };
  },

  created() {
    getUrl().then((res) => {
      console.log(res);
      this.appId = res.result.appId;
      this.redirectUri = res.result.url;
      // this.redirectUri = "http://localhost:8080";
      location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=${this.appId}&redirect_uri=${this.redirectUri}/meeting&scope=snsapi_login`;
    });
  },

  mounted() {
    this.$refs.input.focus();
  },

  components: {},

  computed: {},

  methods: {
    handleNext() {},
  },
};
</script>
<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
  background-color: rgb(242, 242, 242);
  display: flex;
  justify-content: center;
}
.wrapper .inp {
  margin-top: 300px;
}
.wrapper .inp input {
  height: 45px;
  margin-right: 20px;
  font-size: 25px;
  font-weight: 700;
  width: 200px;
}
.wrapper .inp .label {
  font-size: 35px;
  margin-right: 20px;
  vertical-align: sub;
}
</style>